/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBuild = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m16.8 3.5-.4 1.3-7-2.5C5.1.9 2.3 6.4 2.1 6.6L1 8.9 3.4 8c.8-.3 3.7-1 4.4.3 0 0 .4.8 0 2.1L3 20l7.5 2.3 2.8-10.2c.2-.6.6-1 1.2-1.2l-.5 1.5 5.5 1.7 2.8-8.9-5.5-1.7zM9.1 19.7l-3.2-1 3.4-6.8 1.8.6-2 7.2zm6-10.8c-1.3 0-2.6.6-3.3 1.7L9.9 10c.2-1.6-.3-2.6-.4-2.7C8.7 5.8 7 5.5 5.3 5.6c.9-1 2.1-1.9 3.5-1.5l7 2.5-.7 2.3zm3.1 2.7-1.7-.5L18.1 6l1.7.5-1.6 5.1z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgBuild as Build };
